import { 
    apiRequest,
    AwardList,
    AwardPeriodList,
    AwardTypeList,
    AwardSignatories,
    AwardActive,
    AwardInactive,
    AwardDetail,
    AwardPeriodoption
 } from '../../../../../services/adapters/kepegawaian/penghargaanService'

class AwardRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", AwardList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", AwardInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", AwardActive, {
            body: query
        }, true)
    }

    fetchPeriode = async (query, cancelToken) => {
        return await apiRequest('get', AwardPeriodList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchPeriodeOption = async (query, cancelToken) => {
        return await apiRequest('get', AwardPeriodoption, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchType = async (query, cancelToken) => {
        return await apiRequest('get', AwardTypeList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchSignatories = async (query, cancelToken) => {
        return await apiRequest('get', AwardSignatories, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchDetail = async (query, cancelToken) => {
         return await apiRequest('get', AwardDetail, {
            cancelToken: cancelToken,
            params: query
        }, true)       
    }

}

export default AwardRepository